import { readonlyApi } from '../api-readonly';

import {
    EquipmentsSummary,
    CleaningsSummary,
    Top3,
    EquipmentAverage,
    LoadAlerts
} from '../../models/DashboardOverview';

import {
    EnergyConsumption,
    PeakUsage,
    RecipeStats,
    ScopedEquipmentList
} from '../../models/DashboardDetails';

export const DashboardService = {
    getEquipmentsSummary: async () => {
        const { data } = await readonlyApi.get<EquipmentsSummary>('/dashboard/equipments-summary');
        return data;
    },
    getCleaningsSummary: async () => {
        const { data } = await readonlyApi.get<CleaningsSummary>('/dashboard/cleanings-summary');
        return data;
    },
    getTop3: async (startDate?: string, endDate?: string) => {
        const { data } = await readonlyApi.get<Top3>('/dashboard/top3', {
            params: { startDate, endDate }
        });
        return data;
    },
    getEquipmentAverage: async (params: EquipmentAverage.Params) => {
        const { data } = await readonlyApi.get<EquipmentAverage.Response>('/dashboard/equipment-average', {
            params
        });
        return data;
    },
    getAlerts: async (params: LoadAlerts.Params) => {
        const { data } = await readonlyApi.get<LoadAlerts.Response>('/dashboard/alerts', { params });
        return data;
    },
    getScopedEquipmentList: async (params: ScopedEquipmentList.Params) => {
        const { data } = await readonlyApi.get<ScopedEquipmentList.Response>('/dashboard/details/equipments', {
            params
        });
        return data;
    },
    getRecipeStats: async (params: RecipeStats.Params) => {
        const { data } = await readonlyApi.get<RecipeStats.Response>('/dashboard/details/recipe-stats', {
            params
        });
        return data;
    },
    getPeakUsage: async (params: PeakUsage.Params) => {
        const { data } = await readonlyApi.get<PeakUsage.Response>('/dashboard/details/peak-usage', {
            params
        });
        return data;
    },
    getEnergyConsumption: async (params: EnergyConsumption.Params) => {
        const { data } = await readonlyApi.get<EnergyConsumption.Response>('/dashboard/details/energy', {
            params
        });
        return data;
    }
};
